// plugins/fontawesome.ts
import { library, config } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Prevent Font Awesome from auto-adding CSS
config.autoAddCss = false
import '@fortawesome/fontawesome-svg-core/styles.css'

// Solid icons (fas)
import {
  faSearch as faSearchSolid,
  faGift as faGiftSolid,
  faEnvelope as faEnvelopeSolid,
  faChevronRight as faChevronRightSolid,
  faChevronLeft as faChevronLeftSolid,
  faChevronDown as faChevronDownSolid,
  faChevronUp as faChevronUpSolid,
  faCaretDown as faCaretDownSolid,
  faCaretUp as faCaretUpSolid,
  faComments as faCommentsSolid,
  faAnglesLeft as faAnglesLeftSolid,
  faAnglesRight as faAnglesRightSolid,
  faClone as faCloneSolid,
  faCopy as faCopySolid,
  faAngleRight as faAngleRight,
  faAngleLeft as faAngleLeft
} from '@fortawesome/free-solid-svg-icons'

// Light icons (fal)
import {
  faSearch as faSearchLight,
  faGift as faGiftLight,
  faEnvelope as faEnvelopeLight,
  faChevronRight as faChevronRightLight,
  faChevronLeft as faChevronLeftLight,
  faChevronDown as faChevronDownLight,
  faChevronUp as faChevronUpLight,
  faCaretDown as faCaretDownLight,
  faCaretUp as faCaretUpLight,
  faComments as faCommentsLight,
  faAnglesLeft as faAnglesLeftLight,
  faAnglesRight as faAnglesRightLight,
  faClone as faCloneLight,
  faCopy as faCopyLight
} from '@fortawesome/pro-light-svg-icons'

// Brands (fab)
import {
  faTiktok,
  faInstagram,
  faXTwitter,
  faFacebookF,
  faPinterestP,
  faWeibo,
  faYoutube,
  faYelp
} from '@fortawesome/free-brands-svg-icons'


// Add them to the library
library.add(
  faSearchSolid,
  faGiftSolid,
  faEnvelopeSolid,
  faChevronRightSolid,
  faChevronLeftSolid,
  faCaretDownSolid,
  faCaretUpSolid,
  faCommentsSolid,
  faAnglesLeftSolid,
  faAnglesRightSolid,
  faCloneSolid,
  faCopySolid,
  faAngleRight,
  faAngleLeft,
  faSearchLight,
  faGiftLight,
  faEnvelopeLight,
  faChevronRightLight,
  faChevronLeftLight,
  faCaretDownLight,
  faCaretUpLight,
  faCommentsLight,
  faAnglesLeftLight,
  faAnglesRightLight,
  faCloneLight,
  faCopyLight,
  faChevronDownSolid,
  faChevronUpSolid,
  faChevronDownLight,
  faChevronUpLight,
  faTiktok,
  faInstagram,
  faXTwitter,
  faFacebookF,
  faPinterestP,
  faWeibo,
  faYoutube,
  faYelp
)


export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('FontAwesomeIcon', FontAwesomeIcon)
})